function sent(key) {
  fetch('https://api.clubedotruco.com.br/fingerprint', {
    method: 'GET',
    headers: {
      'Affiliate-Code': key,
      'User-Search': window.location.search
    }
  })
}

var url = new URL(window.location.href)
var p = url.searchParams.get('i') || url.searchParams.get('pid')
function cc(n, v) {
  var date = new Date()
  date.setDate(date.getDate() + 30)
  document.cookie = `${n}=${v}; domain=.clubedotruco.com.br; path=/; expires=${date.toUTCString()}`
}
if (p && p.length === 6) {
  sent(p)
  cc('pid', p)
}
